import { useEffect } from "react";
import { BACKEND_URL } from "@/lib/api";
import { Sparkles } from "lucide-react";

export default function ChatDemo() {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = `${BACKEND_URL}/api/widget/widget.js`;
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
      document.querySelectorAll(".msw-bubble, .msw-panel").forEach((el) => el.remove());
      window.__msWidgetLoaded = false;
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#FBF7F5] flex items-center justify-center p-6" data-testid="chat-demo-page">
      <div className="max-w-md text-center">
        <div className="h-14 w-14 rounded-2xl bg-primary flex items-center justify-center mx-auto mb-4 shadow-[0_2px_8px_-2px_hsl(var(--primary)/0.6)]">
          <Sparkles className="h-7 w-7 text-primary-foreground" strokeWidth={1.5} />
        </div>
        <h1 className="font-head text-2xl font-semibold tracking-tight mb-2">Página de prueba del widget</h1>
        <p className="text-sm text-muted-foreground">
          Esta página simula tu sitio (o el theme de Shopify). Tocá la burbuja de chat abajo a la derecha para
          probar el widget con el mismo agente de ventas que atiende WhatsApp e Instagram — texto, imágenes y todo.
        </p>
      </div>
    </div>
  );
}
